import {
  config
} from './config';
import bus from './bus';
/**
 * 清除token缓存，回到登录界面
 */

export function tt() {
  console.log(_this.$refs);
  return;
}
/**
 * 清除token缓存，回到登录界面
 */
export function logout(_this, msg) {



  // console.log(_this.$router.history.current);

  // 如果路由不是在登录页面则跳转路由并弹出消息
  if (_this.$router.history.current.fullPath != '/' && _this.$router.history.current.fullPath != '/login') {

    _this.firstlog = false;

    //踢人
    localStorage.removeItem('access_token');
    sessionStorage.removeItem('navBar');
    sessionStorage.removeItem('time_difference');
    localStorage.removeItem('login');
    localStorage.removeItem('city_tag');
    // 通知关闭socket链接开关
    // bus.$emit('firstlog', false);
    //1.5秒定时器
    setTimeout(() => {

      _this.$router.push({
        path: '/login'
      });

    }, 1500);



    //弹出消息
    _this.$message.error(msg);
  }





  return;

}



// WEBPACK FOOTER //
// ./src/utils/common.js